const API_BASE = '/api/compliance/timeline';

function getAuthHeaders(): HeadersInit {
  const token = sessionStorage.getItem('impersonation_token') || localStorage.getItem('token');
  if (!token) throw new Error('No authentication token found');
  return { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };
}

async function handleResponse<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Unknown error' }));
    throw new Error(err.error || err.message || `API Error: ${res.status}`);
  }
  return res.json();
}

export interface TimelineEvent {
  id: number;
  company_id: number;
  framework_id?: number;
  framework_name?: string;
  event_type: string;
  event_title: string;
  event_description?: string;
  entity_type?: string;
  entity_id?: number;
  performed_by?: number;
  performer_name?: string;
  is_milestone: boolean;
  event_at: string;
  created_at: string;
}

export interface TimelineFilters {
  framework_id?: number;
  event_type?: string;
  milestone_only?: boolean;
  date_from?: string;
  date_to?: string;
  page?: number;
  limit?: number;
}

export const timelineApi = {
  async getEvents(params?: TimelineFilters): Promise<{ events: TimelineEvent[]; total: number }> {
    const q = new URLSearchParams();
    if (params?.framework_id) q.set('framework_id', String(params.framework_id));
    if (params?.event_type) q.set('event_type', params.event_type);
    if (params?.milestone_only) q.set('milestone_only', 'true');
    if (params?.date_from) q.set('date_from', params.date_from);
    if (params?.date_to) q.set('date_to', params.date_to);
    if (params?.page) q.set('page', String(params.page));
    if (params?.limit) q.set('limit', String(params.limit));
    const res = await fetch(`${API_BASE}?${q}`, { headers: getAuthHeaders() });
    return handleResponse(res);
  },

  async createEvent(data: {
    event_type: string;
    event_title: string;
    event_description?: string;
    entity_type?: string;
    entity_id?: number;
    framework_id?: number;
    is_milestone?: boolean;
    event_at?: string;
  }): Promise<TimelineEvent> {
    const res = await fetch(API_BASE, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    const result: any = await handleResponse(res);
    return result.data || result;
  },
};
